/* V-Flat World design system behaviour. Loaded once from layout/theme.liquid. See assets/vfw-ds.css. */
(() => {
  if (window.vfwDs) return;
  window.vfwDs = true;
  document.documentElement.classList.add('ds-js');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      revealObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && !reduceMotion) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  const setupRail = (rail) => {
    const nav = document.querySelector(`[data-ds-rail-nav="${rail.id}"]`);
    if (!nav) return;
    const [prev, next] = nav.querySelectorAll('button');
    const update = () => {
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    const step = () => (rail.firstElementChild?.getBoundingClientRect().width || 300) + 16;
    prev.addEventListener('click', () => rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true });
    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-ds-reveal]').forEach((el) => revealObserver.observe(el));
    // Mark the wrapper (Liquid's video_tag can't take data- attributes) — every video inside autoplays on screen
    root.querySelectorAll('[data-ds-autoplay] video').forEach((video) => {
      video.muted = true;
      videoObserver.observe(video);
    });
    root.querySelectorAll('[data-ds-rail]').forEach(setupRail);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  // Theme editor: re-run when a section is added or re-rendered
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  
